import { Link } from 'react-router-dom';
import { hotRecommendations } from '@/mocks/home';

export default function HotRecommendSection() {
  return (
    <section className="w-full px-4 md:px-6 pt-16 md:pt-20 pb-14 md:pb-18">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 font-bold">热门推荐</h2>
            <p className="text-sm text-foreground-500 mt-1.5">精挑细选，为你推荐最受欢迎的影视内容</p>
          </div>
          <Link
            to="/category"
            className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap cursor-pointer transition-colors"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {hotRecommendations.map((item) => (
            <Link
              key={item.id}
              to={item.link}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-xl overflow-hidden mb-3">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  title={`${item.title} - 茄子视频高清在线观看`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500">
                    <i className="ri-play-fill text-white text-base"></i>
                  </div>
                </div>
                <div className="absolute top-2 left-2 flex flex-wrap gap-1">
                  {item.tags.map((tag) => (
                    <span key={tag} className="px-1.5 py-0.5 text-[10px] font-medium rounded-md bg-accent-500 text-white whitespace-nowrap">
                      {tag}
                    </span>
                  ))}
                </div>
                <div className="absolute bottom-2 right-2 px-1.5 py-0.5 text-[10px] font-semibold rounded bg-black/60 text-accent-400 whitespace-nowrap">
                  {item.rating}
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-0.5 whitespace-nowrap">
                {item.category} · {item.episodes}集
              </p>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap cursor-pointer transition-colors"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}